import type {
  CrearPuerta,
  EditarPuerta,
  Puerta,
  DispositivoPush,
  EnvioPrueba,
  EditarGasto,
  EditarIncidencia,
  EditarHoras,
  LecturaFichaObra,
  ResponsablePosible,
  Obra as ObraOportunidad,
  Categoria,
  CrearCategoria,
  EditarCategoria,
  GuardarMarca,
  GuardarOrganizacion,
  Marca,
  Organizacion,
  PreferenciaAviso,
  TipoAviso,
  EstadoCobro,
  LlaveAcceso,
  EstadoImportacion,
  ImportarChecklists,
  ImportarOportunidades,
  ImportarProyectos,
  ResumenImportacionChecklists,
  GenerarResumenMes,
  ResumenMes,
  ResumenImportacionCrm,
  ResumenImportacionProyectos,
  Instantanea,
  ResumenImportacion,
  AsignarPropiedad,
  CrearEncargo,
  Encargo,
  PresupuestoProveedor,
  AvisarEstancia,
  CrearUsuario,
  EditarUsuario,
  MiembroProyecto,
  UsuarioEquipo,
  PortalCliente,
  EditarIncidenciaPortal,
  ReportarIncidencia,
  CumplimientoPersona,
  EjecucionVisita,
  Factura,
  FacturaDetalle,
  ResultadoItem,
  PanelCompleto,
  PanelPropio,
  Rol,
  ActualizarIncidencia,
  CrearIncidencia,
  Adjunto,
  Aviso,
  CanalComentario,
  Comentar,
  ComentarioIncidencia,
  EntidadAdjunto,
  PresupuestoIncidencia,
  RegistrarPresupuesto,
  Alerta,
  CrearDocumento,
  DocumentoPropiedad,
  GastoPropiedad,
  TotalesGastoPropiedad,
  CrearEstancia,
  CrearFoto,
  CrearMantenimiento,
  Estancia,
  FotoPropiedad,
  Mantenimiento,
  ProveedorVinculado,
  ResumenFicha,
  TarifaEquipo,
  GastoInterno,
  HoraInterna,
  ResumenInterno,
  CerrarOportunidad,
  Contrato,
  CrearActividad,
  CrearOportunidad,
  CrearParty,
  CrearProyecto,
  CrearPropiedad,
  CrearSeccion,
  CrearTarea,
  AplicarAsistente,
  CrmActivity,
  CrmOpportunity,
  InterpretarAsistente,
  PropuestaAsistente,
  CrmPipeline,
  EditarOportunidad,
  AnomaliaGasto,
  ClasificacionIncidencia,
  EditarTarea,
  Equipo,
  Estado2fa,
  EstadoIa,
  PruebaIa,
  EstadoIntegracion,
  EstadoPropiedad,
  EstadoReferido,
  GuardarCredencial,
  Inicio2fa,
  EvaluacionNioCompleta,
  EvaluacionNioReducida,
  EvaluacionNioRequest,
  EventoHistorial,
  Expense,
  ExtractoPropietario,
  FijarTarifa,
  FijarTarifaTrabajo,
  FinanceRate,
  Incidencia,
  CrearEvento,
  CrearItemChecklist,
  CrearPlantilla,
  EditarEvento,
  EditarItemChecklist,
  EditarPlantilla,
  EstadoEvento,
  EventoCalendario,
  ItemChecklist,
  MoverTarea,
  ComentarioTarea,
  EtiquetaTarea,
  MiDia,
  Seccion,
  TareaDetalle,
  Oficio,
  PanelResumen,
  Party,
  PlantillaCompleta,
  PlantillaResumen,
  PropiedadResumen,
  PropertyBilling,
  Proveedor,
  ProyectoDetalle,
  CrearProveedor,
  EditarProveedor,
  Referido,
  RegistrarGasto,
  RegistrarHoras,
  Relacion,
  RequisitosActivacion,
  ResumenMensual,
  SuscripcionPush,
  RolRelacion,
  TablaNio,
  Tarea,
  TarifaSugerida,
  TimeEntry,
  UsuarioSesion,
} from '@matias-asset-os/contracts';

/**
 * Cliente de la API.
 *
 * `credentials: 'include'` es lo que hace que viaje la cookie de sesion. No hay
 * ningun token en memoria ni en almacenamiento del navegador: si esta pagina
 * sufriera una inyeccion de codigo, no habria credencial que robar.
 */
export class ErrorApi extends Error {
  constructor(
    readonly estado: number,
    readonly mensajeClave: string,
    mensaje: string,
  ) {
    super(mensaje);
    this.name = 'ErrorApi';
  }
}

/*
  EL IDIOMA ELEGIDO EN PANTALLA TIENE QUE LLEGAR AL SERVIDOR.

  El conmutador ES/EN/DE cambiaba el idioma solo dentro del navegador. Eso
  traduce los rotulos —los tiene la propia aplicacion— pero no los titulos y las
  descripciones que escribe una persona: esos los traduce el servidor, y el
  servidor seguia creyendo que se leia en castellano porque nadie se lo habia
  dicho. Resultado: la pantalla en ingles y las incidencias en castellano.

  Se manda en `Accept-Language`, que es la cabecera que existe para esto y que
  el navegador deja poner sin permiso adicional. Se lee de donde ya estaba
  guardado el idioma para que las PRIMERAS peticiones —las de arrancar— tampoco
  salgan sin el.
*/
let idiomaActual = 'es';
try {
  const guardado = localStorage.getItem('aos_idioma');
  if (guardado === 'es' || guardado === 'en' || guardado === 'de') idiomaActual = guardado;
} catch {
  /* sin almacenamiento local se empieza en castellano, que es el del equipo */
}

/** La pantalla avisa aqui cuando alguien cambia de idioma. */
export function usarIdioma(idioma: string): void {
  idiomaActual = idioma;
}

/** Un sitio del mapa, tal y como lo devuelve el buscador de direcciones. */
export interface Lugar {
  etiqueta: string;
  lat: number;
  lon: number;
  municipio: string | null;
  zona: string | null;
  codigoPostal: string | null;
}

async function pedir<T>(ruta: string, opciones: RequestInit = {}): Promise<T> {
  // El tipo de contenido solo se declara cuando hay cuerpo: anunciarlo con el
  // cuerpo vacio hace que el servidor intente interpretar un JSON inexistente.
  const cabeceras: Record<string, string> = { ...(opciones.headers as Record<string, string>) };
  if (opciones.body !== undefined && cabeceras['Content-Type'] === undefined) {
    cabeceras['Content-Type'] = 'application/json';
  }
  if (cabeceras['Accept-Language'] === undefined) cabeceras['Accept-Language'] = idiomaActual;

  const respuesta = await fetch(`/api${ruta}`, {
    credentials: 'include',
    ...opciones,
    headers: cabeceras,
  });

  const cuerpo: unknown = await respuesta.json().catch(() => ({}));

  if (!respuesta.ok) {
    const detalle = cuerpo as { mensajeClave?: string; mensaje?: string };
    throw new ErrorApi(
      respuesta.status,
      detalle.mensajeClave ?? 'error.servidor',
      detalle.mensaje ?? 'Error',
    );
  }
  return cuerpo as T;
}

const enviar = (ruta: string, cuerpo: unknown) =>
  pedir(ruta, { method: 'POST', body: JSON.stringify(cuerpo) });

function qs(q?: Record<string, string | undefined>): string {
  if (!q) return '';
  const p = new URLSearchParams();
  for (const [k, v] of Object.entries(q)) if (v) p.set(k, v);
  const s = p.toString();
  return s ? `?${s}` : '';
}

/**
 * Un fichero, en base64 y sin el prefijo `data:`.
 *
 * Lo usan los adjuntos y la lectura de fichas de obra: viajan por el mismo
 * canal protegido que el resto, sin una segunda puerta con otras reglas.
 */
function enBase64(fichero: File): Promise<string> {
  return new Promise<string>((resolver, rechazar) => {
    const lector = new FileReader();
    lector.onload = () => {
      const r = String(lector.result);
      resolver(r.slice(r.indexOf(',') + 1));
    };
    lector.onerror = () => rechazar(lector.error);
    lector.readAsDataURL(fichero);
  });
}

export const api = {
  entrar: (email: string, password: string) =>
    pedir<{ usuario: UsuarioSesion }>('/auth/login', {
      method: 'POST',
      body: JSON.stringify({ email, password }),
    }),
  salir: () => pedir<{ ok: true }>('/auth/logout', { method: 'POST' }),
  yo: () =>
    pedir<{ usuario: UsuarioSesion; rolReal: Rol; viendoComo: Rol | null }>('/me'),
  /** Ver la aplicación con otro rol. El servidor sólo permite bajar privilegios. */
  verComo: (rol: Rol | null) =>
    pedir<{ ok: true }>('/me/ver-como', { method: 'POST', body: JSON.stringify({ rol }) }),

  // Panel
  panel: () => pedir<{ panel: PanelResumen }>('/panel'),
  alertas: () => pedir<{ alertas: Alerta[] }>('/alertas'),
  marcarAlertasLeidas: () =>
    pedir<{ marcadas: number }>('/alertas/leer-todas', { method: 'POST' }),
  // --- Facturas -------------------------------------------------------------
  facturas: (q?: { estado?: string; propiedad?: string }) => {
    const p = new URLSearchParams();
    if (q?.estado) p.set('estado', q.estado);
    if (q?.propiedad) p.set('propiedad', q.propiedad);
    const s = p.toString();
    return pedir<{ facturas: Factura[] }>(`/facturas${s ? `?${s}` : ''}`);
  },
  factura: (id: string) => pedir<{ factura: FacturaDetalle }>(`/facturas/${id}`),
  facturarPendiente: (propiedadId: string) =>
    pedir<{ factura: FacturaDetalle }>(`/propiedades/${propiedadId}/facturar`, { method: 'POST' }),
  emitirFactura: (id: string) =>
    pedir<{ factura: FacturaDetalle }>(`/facturas/${id}/emitir`, { method: 'POST' }),
  cobrarFactura: (id: string) =>
    pedir<{ factura: FacturaDetalle }>(`/facturas/${id}/cobrar`, { method: 'POST' }),
  anularFactura: (id: string, motivo: string) =>
    pedir<{ factura: FacturaDetalle }>(`/facturas/${id}/anular`, {
      method: 'POST',
      body: JSON.stringify({ motivo }),
    }),

  // --- Ejecucion de visitas --------------------------------------------------
  ejecuciones: (propiedadId: string) =>
    pedir<{ ejecuciones: EjecucionVisita[] }>(`/propiedades/${propiedadId}/ejecuciones`),
  iniciarVisita: (
    propiedadId: string,
    datos: { plantillaId?: string; eventoId?: string; notas?: string },
  ) =>
    pedir<{ ejecucion: EjecucionVisita }>(`/propiedades/${propiedadId}/ejecuciones`, {
      method: 'POST',
      body: JSON.stringify(datos),
    }),
  /** Salir de la lista sin cerrarla: la visita se da por no hecha. */
  descartarVisita: (ejecucionId: string) =>
    pedir<{ ok: true }>(`/ejecuciones/${ejecucionId}/descartar`, { method: 'POST' }),
  reabrirVisita: (visitaId: string) =>
    pedir<{ ejecucion: EjecucionVisita }>(`/ejecuciones/${visitaId}/reabrir`, { method: 'POST' }),
  /** Una visita concreta: se vuelve a pedir al colgarle una foto a un punto. */
  ejecucion: (visitaId: string) =>
    pedir<{ ejecucion: EjecucionVisita }>(`/ejecuciones/${visitaId}`),
  marcarItemVisita: (visitaId: string, itemId: string, resultado: ResultadoItem, notas?: string) =>
    pedir<{ ejecucion: EjecucionVisita }>(`/ejecuciones/${visitaId}/items/${itemId}`, {
      method: 'POST',
      body: JSON.stringify({ resultado, notas }),
    }),
  /** Lo que se escribe en un punto. Vale tambien con la visita ya cerrada. */
  anotarItemVisita: (visitaId: string, itemId: string, notas: string | null) =>
    pedir<{ ejecucion: EjecucionVisita }>(`/ejecuciones/${visitaId}/items/${itemId}/nota`, {
      method: 'POST',
      body: JSON.stringify({ notas }),
    }),
  anotarVisita: (visitaId: string, notas: string | null) =>
    pedir<{ ejecucion: EjecucionVisita }>(`/ejecuciones/${visitaId}/nota`, {
      method: 'POST',
      body: JSON.stringify({ notas }),
    }),
  completarVisita: (visitaId: string, notas?: string) =>
    pedir<{ ejecucion: EjecucionVisita; incidenciasCreadas: number }>(
      `/ejecuciones/${visitaId}/completar`,
      { method: 'POST', body: JSON.stringify({ notas }) },
    ),
  cumplimiento: () => pedir<{ cumplimiento: CumplimientoPersona[] }>('/equipo/cumplimiento'),

  // --- Anomalias de gasto por propiedad --------------------------------------
  anomaliasPropiedad: (propiedadId: string) =>
    pedir<{ anomalias: AnomaliaGasto[] }>(`/ia/anomalias?propiedad=${propiedadId}`),

  // --- Resumenes mensuales del portal del cliente -----------------------------
  resumenesMes: (anio: number, mes: number) =>
    pedir<{ resumenes: ResumenMes[] }>(`/ia/resumenes?anio=${anio}&mes=${mes}`),
  generarResumenMes: (datos: GenerarResumenMes) =>
    pedir<{ resumen: ResumenMes }>('/ia/resumenes', {
      method: 'POST',
      body: JSON.stringify(datos),
    }),
  editarResumenMes: (id: string, texto: string) =>
    pedir<{ resumen: ResumenMes }>(`/ia/resumenes/${id}`, {
      method: 'PATCH',
      body: JSON.stringify({ texto }),
    }),
  publicarResumenMes: (id: string) =>
    pedir<{ resumen: ResumenMes }>(`/ia/resumenes/${id}/publicar`, { method: 'POST' }),
  retirarResumenMes: (id: string) =>
    pedir<{ resumen: ResumenMes }>(`/ia/resumenes/${id}/retirar`, { method: 'POST' }),

  // --- Informes en PDF -------------------------------------------------------
  urlInformePersona: (userId: string, anio: number, mes: number) =>
    `/api/informes/persona/${userId}?anio=${anio}&mes=${mes}`,
  urlInformeCartera: (anio: number, mes: number) =>
    `/api/informes/cartera?anio=${anio}&mes=${mes}`,

  /** El panel de cada persona: lo suyo y lo de SUS casas. */
  panelPropio: () => pedir<{ panel: PanelPropio }>('/panel/mio'),

  panelCompleto: (anio?: number, mes?: number) =>
    pedir<{ panel: PanelCompleto }>(
      `/panel/completo${anio && mes ? `?anio=${anio}&mes=${mes}` : ''}`,
    ),

  // --- Avisos --------------------------------------------------------------
  avisos: () => pedir<{ avisos: Aviso[] }>('/avisos'),
  marcarAvisoLeido: (entidadId: string) =>
    pedir<{ ok: true }>(`/avisos/${entidadId}/leido`, { method: 'POST' }),
  marcarAvisosLeidos: () =>
    pedir<{ marcados: number }>('/avisos/leer-todos', { method: 'POST' }),

  // --- Detalle de incidencia -----------------------------------------------
  comentarios: (incidenciaId: string, canal: CanalComentario) =>
    pedir<{ comentarios: ComentarioIncidencia[] }>(
      `/incidencias/${incidenciaId}/comentarios?canal=${canal}`,
    ),
  comentar: (incidenciaId: string, datos: Comentar) =>
    pedir<{ comentario: ComentarioIncidencia }>(`/incidencias/${incidenciaId}/comentarios`, {
      method: 'POST',
      body: JSON.stringify(datos),
    }),
  presupuestos: (incidenciaId: string) =>
    pedir<{ presupuestos: PresupuestoIncidencia[] }>(`/incidencias/${incidenciaId}/presupuestos`),
  registrarPresupuesto: (incidenciaId: string, datos: RegistrarPresupuesto) =>
    pedir<{ presupuesto: PresupuestoIncidencia }>(`/incidencias/${incidenciaId}/presupuestos`, {
      method: 'POST',
      body: JSON.stringify(datos),
    }),
  /** Quien del equipo puede encargarse de las incidencias de una casa, y quien no. */
  responsablesPosibles: (propiedadId: string) =>
    pedir<{ responsables: ResponsablePosible[] }>(
      `/propiedades/${propiedadId}/responsables-posibles`,
    ),
  actualizarIncidencia: (incidenciaId: string, datos: ActualizarIncidencia) =>
    pedir<{ ok: true }>(`/incidencias/${incidenciaId}/detalle`, {
      method: 'PATCH',
      body: JSON.stringify(datos),
    }),

  // --- Adjuntos ------------------------------------------------------------
  adjuntos: (entidad: EntidadAdjunto, entidadId: string) =>
    pedir<{ adjuntos: Adjunto[] }>(`/adjuntos?entidad=${entidad}&entidadId=${entidadId}`),
  /**
   * Sube un fichero. Se lee en el navegador y viaja en base64 por el mismo
   * canal protegido que el resto: no hay una segunda puerta con otras reglas.
   */
  subirAdjunto: async (
    entidad: EntidadAdjunto,
    entidadId: string,
    fichero: File,
    visibleCliente?: boolean,
  ) => {
    const contenidoBase64 = await enBase64(fichero);
    return pedir<{ adjunto: Adjunto }>('/adjuntos', {
      method: 'POST',
      body: JSON.stringify({
        entidad,
        entidadId,
        nombreFichero: fichero.name,
        tipoMime: fichero.type,
        contenidoBase64,
        ...(visibleCliente === undefined ? {} : { visibleCliente }),
      }),
    });
  },
  urlAdjunto: (adjuntoId: string) => `/api/adjuntos/${adjuntoId}/contenido`,

  // --- Equipo -------------------------------------------------------------
  equipo: () => pedir<{ equipo: UsuarioEquipo[] }>('/equipo'),
  crearUsuario: (datos: CrearUsuario) =>
    pedir<{ usuario: UsuarioEquipo }>('/equipo', {
      method: 'POST',
      body: JSON.stringify(datos),
    }),
  editarUsuario: (id: string, datos: EditarUsuario) =>
    pedir<{ usuario: UsuarioEquipo }>(`/equipo/${id}`, {
      method: 'POST',
      body: JSON.stringify(datos),
    }),
  restablecerPassword: (id: string, password: string) =>
    pedir<{ ok: true }>(`/equipo/${id}/password`, {
      method: 'POST',
      body: JSON.stringify({ password }),
    }),
  ocultarUsuario: (id: string) =>
    pedir<{ usuario: UsuarioEquipo }>(`/equipo/${id}/ocultar`, { method: 'POST' }),
  reactivarUsuario: (id: string) =>
    pedir<{ usuario: UsuarioEquipo }>(`/equipo/${id}/reactivar`, { method: 'POST' }),
  eliminarUsuario: (id: string) =>
    pedir<{ ok: true }>(`/equipo/${id}/eliminar`, { method: 'POST' }),
  asignarPropiedadAUsuario: (id: string, datos: AsignarPropiedad) =>
    pedir<{ usuario: UsuarioEquipo }>(`/equipo/${id}/propiedades`, {
      method: 'POST',
      body: JSON.stringify(datos),
    }),
  retirarPropiedadDeUsuario: (id: string, propiedadId: string) =>
    pedir<{ usuario: UsuarioEquipo }>(`/equipo/${id}/propiedades/${propiedadId}/retirar`, {
      method: 'POST',
    }),

  // --- Miembros de un proyecto --------------------------------------------
  miembrosProyecto: (proyectoId: string) =>
    pedir<{ miembros: MiembroProyecto[] }>(`/proyectos/proyectos/${proyectoId}/miembros`),
  anadirMiembroProyecto: (proyectoId: string, usuarioId: string, rol?: string) =>
    pedir<{ miembros: MiembroProyecto[] }>(`/proyectos/proyectos/${proyectoId}/miembros`, {
      method: 'POST',
      body: JSON.stringify({ usuarioId, rol }),
    }),
  retirarMiembroProyecto: (proyectoId: string, usuarioId: string) =>
    pedir<{ miembros: MiembroProyecto[] }>(
      `/proyectos/proyectos/${proyectoId}/miembros/${usuarioId}/retirar`,
      { method: 'POST' },
    ),

  // --- Portal del proveedor -----------------------------------------------
  misEncargos: () => pedir<{ encargos: Encargo[] }>('/proveedor/encargos'),
  aceptarEncargo: (id: string) =>
    pedir<{ encargo: Encargo }>(`/proveedor/encargos/${id}/aceptar`, { method: 'POST' }),
  iniciarEncargo: (id: string) =>
    pedir<{ encargo: Encargo }>(`/proveedor/encargos/${id}/iniciar`, { method: 'POST' }),
  solicitarFinEncargo: (id: string) =>
    pedir<{ encargo: Encargo }>(`/proveedor/encargos/${id}/solicitar-fin`, { method: 'POST' }),
  rechazarEncargo: (id: string, motivo: string) =>
    pedir<{ encargo: Encargo }>(`/proveedor/encargos/${id}/rechazar`, {
      method: 'POST',
      body: JSON.stringify({ motivo }),
    }),
  presupuestoEncargo: (id: string, datos: PresupuestoProveedor) =>
    pedir<{ encargo: Encargo }>(`/proveedor/encargos/${id}/presupuesto`, {
      method: 'POST',
      body: JSON.stringify(datos),
    }),

  // --- Encargos desde la ficha interna ------------------------------------
  encargosDeIncidencia: (incidenciaId: string) =>
    pedir<{ encargos: Array<{ id: string; estado: string; proveedorNombre: string; motivoRechazo: string | null }> }>(
      `/incidencias/${incidenciaId}/encargos`,
    ),
  encargar: (incidenciaId: string, datos: CrearEncargo) =>
    pedir<{ encargo: { id: string } }>(`/incidencias/${incidenciaId}/encargos`, {
      method: 'POST',
      body: JSON.stringify(datos),
    }),
  completarEncargo: (id: string) =>
    pedir<{ ok: true }>(`/encargos/${id}/completar`, { method: 'POST' }),

  // --- Portal del propietario ---------------------------------------------
  // Rutas propias: un cliente nunca pasa por las internas de /propiedades.
  portal: () => pedir<{ portal: PortalCliente }>('/portal'),
  portalReportar: (propiedadId: string, datos: ReportarIncidencia) =>
    pedir<{ incidencia: { id: string; codigo: string } }>(
      `/portal/propiedades/${propiedadId}/incidencias`,
      { method: 'POST', body: JSON.stringify(datos) },
    ),
  /** El resumen con IA de su casa. Cuesta una llamada: solo al abrir la seccion. */
  portalResumen: (propiedadId: string) =>
    pedir<{ resumen: string | null }>(`/portal/propiedades/${propiedadId}/resumen`, {
      method: 'POST',
    }),
  /** El dueno corrige el titulo o la descripcion de lo que el mismo reporto. */
  portalEditarIncidencia: (incidenciaId: string, datos: EditarIncidenciaPortal) =>
    pedir<{ ok: true }>(`/portal/incidencias/${incidenciaId}`, {
      method: 'POST',
      body: JSON.stringify(datos),
    }),
  cambiarPassword: (actual: string, nueva: string) =>
    pedir<{ ok: true }>('/auth/password', {
      method: 'POST',
      body: JSON.stringify({ actual, nueva }),
    }),
  portalMensaje: (incidenciaId: string, cuerpo: string) =>
    pedir<{ ok: true }>(`/portal/incidencias/${incidenciaId}/mensajes`, {
      method: 'POST',
      body: JSON.stringify({ cuerpo }),
    }),
  portalEstancia: (propiedadId: string, datos: AvisarEstancia) =>
    pedir<{ ok: true }>(`/portal/propiedades/${propiedadId}/estancias`, {
      method: 'POST',
      body: JSON.stringify(datos),
    }),
  portalFacturacion: (propiedadId: string, datos: string) =>
    pedir<{ ok: true }>(`/portal/propiedades/${propiedadId}/facturacion`, {
      method: 'POST',
      body: JSON.stringify({ datos }),
    }),
  eliminarAdjunto: (adjuntoId: string) =>
    pedir<{ ok: true }>(`/adjuntos/${adjuntoId}/eliminar`, { method: 'POST' }),
  /** Comparte u oculta una evidencia al portal del cliente. */
  visibilidadAdjunto: (adjuntoId: string, visible: boolean) =>
    pedir<{ adjunto: Adjunto }>(`/adjuntos/${adjuntoId}/visibilidad`, {
      method: 'POST',
      body: JSON.stringify({ visible }),
    }),

  // --- Interno (gastos y horas de la organizacion) -------------------------
  internoResumen: (q?: { desde?: string; hasta?: string }) =>
    pedir<{ resumen: ResumenInterno }>(`/interno/resumen${qs(q)}`),
  internoGastos: (q?: {
    desde?: string;
    hasta?: string;
    categoria?: string;
    estado?: string;
    ambito?: string;
  }) => pedir<{ gastos: GastoInterno[] }>(`/interno/gastos${qs(q)}`),
  internoHoras: (q?: { desde?: string; hasta?: string; ambito?: string }) =>
    pedir<{ horas: HoraInterna[] }>(`/interno/horas${qs(q)}`),

  // --- Ficha de propiedad --------------------------------------------------
  resumenFicha: (id: string) => pedir<{ resumen: ResumenFicha }>(`/propiedades/${id}/resumen`),
  visitasDePropiedad: (id: string) =>
    pedir<{ visitas: EventoCalendario[] }>(`/propiedades/${id}/visitas`),
  estancias: (id: string) => pedir<{ estancias: Estancia[] }>(`/propiedades/${id}/estancias`),
  crearEstancia: (id: string, datos: CrearEstancia) =>
    pedir<{ estancia: Estancia }>(`/propiedades/${id}/estancias`, {
      method: 'POST',
      body: JSON.stringify(datos),
    }),
  anularEstancia: (propiedadId: string, estanciaId: string) =>
    pedir<{ ok: true }>(`/propiedades/${propiedadId}/estancias/${estanciaId}/anular`, {
      method: 'POST',
    }),
  mantenimiento: (id: string) =>
    pedir<{ mantenimiento: Mantenimiento[] }>(`/propiedades/${id}/mantenimiento`),
  crearMantenimiento: (id: string, datos: CrearMantenimiento) =>
    pedir<{ tarea: Mantenimiento }>(`/propiedades/${id}/mantenimiento`, {
      method: 'POST',
      body: JSON.stringify(datos),
    }),
  mantenimientoHecho: (id: string, tareaId: string, fecha?: string) =>
    pedir<{ tarea: Mantenimiento }>(`/propiedades/${id}/mantenimiento/${tareaId}/hecho`, {
      method: 'POST',
      body: JSON.stringify({ fecha }),
    }),
  proveedoresDePropiedad: (id: string) =>
    pedir<{ proveedores: ProveedorVinculado[] }>(`/propiedades/${id}/proveedores`),
  vincularProveedor: (id: string, providerId: string) =>
    pedir<{ ok: true }>(`/propiedades/${id}/proveedores`, {
      method: 'POST',
      body: JSON.stringify({ providerId }),
    }),
  desvincularProveedor: (id: string, providerId: string) =>
    pedir<{ ok: true }>(`/propiedades/${id}/proveedores/${providerId}/desvincular`, {
      method: 'POST',
    }),
  fotos: (id: string) => pedir<{ fotos: FotoPropiedad[] }>(`/propiedades/${id}/fotos`),
  anadirFoto: (id: string, datos: CrearFoto) =>
    pedir<{ foto: FotoPropiedad }>(`/propiedades/${id}/fotos`, {
      method: 'POST',
      body: JSON.stringify(datos),
    }),
  eliminarFoto: (id: string, fotoId: string) =>
    pedir<{ ok: true }>(`/propiedades/${id}/fotos/${fotoId}/eliminar`, { method: 'POST' }),
  tarifasEquipo: (id: string) =>
    pedir<{ tarifas: TarifaEquipo[] }>(`/propiedades/${id}/tarifas-equipo`),
  gastosDePropiedad: (id: string) =>
    pedir<{ gastos: GastoPropiedad[]; totales: TotalesGastoPropiedad }>(
      `/propiedades/${id}/gastos`,
    ),
  documentos: (id: string) =>
    pedir<{ documentos: DocumentoPropiedad[] }>(`/propiedades/${id}/documentos`),
  /** Marca la casa ocupada o vacia. Devuelve las estancias ya actualizadas. */
  fijarOcupacion: (id: string, ocupada: boolean, huesped?: string) =>
    pedir<{ estancias: Estancia[] }>(`/propiedades/${id}/ocupacion`, {
      method: 'POST',
      body: JSON.stringify({ ocupada, ...(huesped ? { huesped } : {}) }),
    }),
  eliminarDocumento: (propiedadId: string, documentoId: string) =>
    pedir<{ ok: true }>(`/propiedades/${propiedadId}/documentos/${documentoId}/eliminar`, {
      method: 'POST',
    }),
  eliminarEvento: (eventoId: string) =>
    pedir<{ ok: true }>(`/calendario/${eventoId}/eliminar`, { method: 'POST' }),
  /** Compartirlo con el dueño en su portal, o quitarlo de ahí. */
  compartirDocumento: (propiedadId: string, documentoId: string, visibleCliente: boolean) =>
    pedir<{ ok: true }>(`/propiedades/${propiedadId}/documentos/${documentoId}/compartir`, {
      method: 'POST',
      body: JSON.stringify({ visibleCliente }),
    }),
  crearDocumento: (id: string, datos: CrearDocumento) =>
    pedir<{ documento: DocumentoPropiedad }>(`/propiedades/${id}/documentos`, {
      method: 'POST',
      body: JSON.stringify(datos),
    }),

  // Cartera
  propiedades: () => pedir<{ propiedades: PropiedadResumen[] }>('/propiedades'),
  propiedad: (id: string) => pedir<{ propiedad: PropiedadResumen }>(`/propiedades/${id}`),
  crearPropiedad: (datos: CrearPropiedad) =>
    pedir<{ propiedad: PropiedadResumen }>('/propiedades', {
      method: 'POST',
      body: JSON.stringify(datos),
    }),
  requisitos: (id: string) =>
    pedir<{ requisitos: RequisitosActivacion }>(`/propiedades/${id}/requisitos`),
  cambiarEstado: (id: string, estado: EstadoPropiedad, motivo?: string) =>
    enviar(`/propiedades/${id}/estado`, { estado, motivo }),

  // Relaciones, contrato, incidencias e historial
  relaciones: (id: string) => pedir<{ relaciones: Relacion[] }>(`/propiedades/${id}/relaciones`),
  contratos: (id: string) => pedir<{ contratos: Contrato[] }>(`/propiedades/${id}/contratos`),
  incidencias: (id: string) =>
    pedir<{ incidencias: Incidencia[] }>(`/propiedades/${id}/incidencias`),
  historial: (id: string) => pedir<{ eventos: EventoHistorial[] }>(`/propiedades/${id}/historial`),

  editarPropiedad: (id: string, datos: Record<string, unknown>) =>
    pedir<{ ok: true }>(`/propiedades/${id}`, { method: 'PATCH', body: JSON.stringify(datos) }),

  // Usuarios internos: solo para elegir el responsable de una propiedad.
  usuarios: () =>
    pedir<{ usuarios: Array<{ id: string; nombre: string; rol: string }> }>('/usuarios'),

  // Personas y empresas
  partes: () => pedir<{ partes: Party[] }>('/partes'),
  crearParty: (datos: CrearParty) =>
    pedir<{ party: Party }>('/partes', { method: 'POST', body: JSON.stringify(datos) }),
  editarParty: (id: string, datos: Partial<CrearParty>) =>
    pedir<{ ok: true }>(`/partes/${id}`, { method: 'PATCH', body: JSON.stringify(datos) }),

  // Relaciones con vigencia
  abrirRelacion: (
    propiedadId: string,
    datos: { partyId: string; rol: RolRelacion; desde?: string },
  ) => enviar(`/propiedades/${propiedadId}/relaciones`, datos),
  finalizarRelacion: (relacionId: string, datos: { motivo: string; hasta?: string }) =>
    enviar(`/relaciones/${relacionId}/finalizar`, datos),

  // Contrato de gestion
  crearContrato: (
    propiedadId: string,
    datos: {
      billingPartyId: string;
      desde?: string;
      moneda?: string;
      umbralAprobacionCents?: number;
    },
  ) =>
    pedir<{ contrato: Contrato }>(`/propiedades/${propiedadId}/contratos`, {
      method: 'POST',
      body: JSON.stringify(datos),
    }),
  fijarTarifa: (contratoId: string, datos: FijarTarifa) =>
    pedir<{ contrato: Contrato }>(`/contratos/${contratoId}/tarifa`, {
      method: 'POST',
      body: JSON.stringify(datos),
    }),
  activarContrato: (contratoId: string) =>
    pedir<{ contrato: Contrato }>(`/contratos/${contratoId}/activar`, { method: 'POST' }),
  finalizarContrato: (contratoId: string, datos: { motivo: string; hasta: string }) =>
    pedir<{ contrato: Contrato }>(`/contratos/${contratoId}/finalizar`, {
      method: 'POST',
      body: JSON.stringify(datos),
    }),

  // Evaluacion operativa
  evaluaciones: (propiedadId: string) =>
    pedir<{ evaluaciones: Array<EvaluacionNioCompleta | EvaluacionNioReducida> }>(
      `/propiedades/${propiedadId}/nio`,
    ),
  crearEvaluacion: (propiedadId: string, datos: EvaluacionNioRequest) =>
    pedir<{ evaluacion: EvaluacionNioCompleta | EvaluacionNioReducida }>(
      `/propiedades/${propiedadId}/nio`,
      { method: 'POST', body: JSON.stringify(datos) },
    ),
  editarEvaluacion: (evaluacionId: string, datos: EvaluacionNioRequest) =>
    pedir<{ ok: true }>(`/nio/${evaluacionId}`, {
      method: 'PATCH',
      body: JSON.stringify(datos),
    }),
  validarEvaluacion: (evaluacionId: string) =>
    pedir<{ evaluacion: EvaluacionNioCompleta }>(`/nio/${evaluacionId}/validar`, {
      method: 'POST',
    }),
  tablasNio: () => pedir<{ tablas: TablaNio[] }>('/nio/tablas'),

  // Incidencias
  crearIncidencia: (propiedadId: string, datos: CrearIncidencia) =>
    pedir<{ incidencia: Incidencia }>(`/propiedades/${propiedadId}/incidencias`, {
      method: 'POST',
      body: JSON.stringify(datos),
    }),
  /** Abierta ↔ En curso. Cerrar es otra cosa: exige resolucion. */
  incidenciaEnCurso: (incidenciaId: string, enCurso: boolean) =>
    pedir<{ incidencia: Incidencia }>(`/incidencias/${incidenciaId}/en-curso`, {
      method: 'POST',
      body: JSON.stringify({ enCurso }),
    }),
  /*
    EL TITULO Y LA DESCRIPCION SE CORRIGEN.

    Un titulo lo escribe quien abre la incidencia, muchas veces desde la casa y
    con prisa, y muchas veces se queda mal: «fallo electrico» cuando es la vela
    del salon. Quien esta delante tiene que poder arreglarlo, y eso incluye a un
    manager, no solo a Direccion.
  */
  editarIncidencia: (incidenciaId: string, datos: EditarIncidencia) =>
    pedir<{ incidencia: Incidencia }>(`/incidencias/${incidenciaId}`, {
      method: 'PATCH',
      body: JSON.stringify(datos),
    }),
  cerrarIncidencia: (incidenciaId: string, resolucion: string) =>
    enviar(`/incidencias/${incidenciaId}/cerrar`, { resolucion }),
  anularIncidencia: (incidenciaId: string, motivo: string) =>
    enviar(`/incidencias/${incidenciaId}/anular`, { motivo }),

  // --- Oportunidades de obra ------------------------------------------------
  /*
    La obra se guarda ENTERA. La ficha se edita como una unidad —mover la etapa
    escribe un apunte en el historial, anadir un contacto escribe otro— y una
    llamada por campo obligaria a repetir esos efectos aqui.
  */
  /*
    AVISOS EN EL MOVIL. La clave publica es lo unico que el navegador necesita
    para suscribirse; la privada no sale nunca del servidor.
  */
  pushClave: (endpoint?: string) =>
    pedir<{ clave: string | null; dispositivos: DispositivoPush[] }>(
      `/push/clave${endpoint ? `?endpoint=${encodeURIComponent(endpoint)}` : ''}`,
    ),
  pushPrueba: () => pedir<{ envios: EnvioPrueba[] }>('/push/prueba', { method: 'POST' }),
  pushSuscribir: (datos: SuscripcionPush) =>
    pedir<{ ok: true }>('/push/suscribir', { method: 'POST', body: JSON.stringify(datos) }),
  pushBaja: (endpoint: string) =>
    pedir<{ ok: true }>('/push/baja', { method: 'POST', body: JSON.stringify({ endpoint }) }),
  /** Donde cae una direccion: municipio, barrio y punto exacto. */
  mapaBuscar: (texto: string) =>
    pedir<{ lugares: Lugar[] }>(`/mapa/buscar?texto=${encodeURIComponent(texto)}`),
  /** De donde salen los cuadros del mapa. Lo decide el servidor. */
  mapaConfig: () =>
    pedir<{
      calle: { url: string; atribucion: string; zoomMaximo: number };
      satelite: { url: string; atribucion: string; zoomMaximo: number } | null;
    }>('/mapa/config'),
  /*
    PUERTA A PUERTA. Dos puertas de alta a proposito: `registrarPuerta` es la de
    la calle —pide lo minimo y devuelve la ficha hecha— y `guardarPuerta` la de
    la oficina, que guarda la ficha entera con sus seguimientos.
  */
  puertas: () => pedir<{ puertas: Puerta[] }>('/puertas'),
  puerta: (id: string) => pedir<{ puerta: Puerta }>(`/puertas/${id}`),
  registrarPuerta: (datos: CrearPuerta) =>
    pedir<{ puerta: Puerta }>('/puertas', { method: 'POST', body: JSON.stringify(datos) }),
  guardarPuerta: (id: string, datos: EditarPuerta) =>
    pedir<{ puerta: Puerta }>(`/puertas/${id}`, { method: 'PUT', body: JSON.stringify(datos) }),
  eliminarPuerta: (id: string) =>
    pedir<{ ok: true }>(`/puertas/${id}/eliminar`, { method: 'POST' }),
  /** Donde estoy: del punto del movil a la calle con su numero. */
  lugarAqui: (lat: number, lon: number) =>
    pedir<{ lugar: Lugar | null }>(`/mapa/aqui?lat=${lat}&lon=${lon}`),
  obras: () => pedir<{ obras: ObraOportunidad[] }>('/obras'),
  guardarObra: (obra: ObraOportunidad) =>
    pedir<{ obra: ObraOportunidad }>(`/obras/${obra.id}`, {
      method: 'PUT',
      body: JSON.stringify(obra),
    }),
  eliminarObra: (obraId: string) =>
    pedir<{ ok: true }>(`/obras/${obraId}/eliminar`, { method: 'POST' }),
  /*
    LA RUTINA DIARIA. Se sube la foto de la ficha rellenada a mano y vuelve un
    BORRADOR con lo que se ha leido y lo que no. No da de alta nada: guardar es
    otro paso, y lo hace una persona.
  */
  leerFichaDeObra: async (fichero: File) =>
    pedir<{ lectura: LecturaFichaObra }>('/obras/leer-ficha', {
      method: 'POST',
      body: JSON.stringify({
        nombreFichero: fichero.name,
        tipoMime: fichero.type,
        contenidoBase64: await enBase64(fichero),
      }),
    }),

  // --- CRM -----------------------------------------------------------------
  crmEmbudos: () => pedir<{ embudos: CrmPipeline[] }>('/crm/embudos'),
  crmOportunidad: (id: string) => pedir<{ oportunidad: CrmOpportunity }>(`/crm/oportunidades/${id}`),
  /** Quién trabaja el CRM: la dirección y los managers con acceso. */
  crmPersonas: () => pedir<{ personas: Array<{ id: string; nombre: string }> }>('/crm/personas'),
  crmOportunidades: (embudoId: string) =>
    pedir<{ oportunidades: CrmOpportunity[] }>(`/crm/embudos/${embudoId}/oportunidades`),
  crmCrearOportunidad: (datos: CrearOportunidad) =>
    pedir<{ oportunidad: CrmOpportunity }>('/crm/oportunidades', {
      method: 'POST',
      body: JSON.stringify(datos),
    }),
  crmEditarOportunidad: (id: string, datos: EditarOportunidad) =>
    pedir<{ oportunidad: CrmOpportunity }>(`/crm/oportunidades/${id}`, {
      method: 'PATCH',
      body: JSON.stringify(datos),
    }),
  crmMoverOportunidad: (id: string, stageId: string) =>
    pedir<{ oportunidad: CrmOpportunity }>(`/crm/oportunidades/${id}/mover`, {
      method: 'POST',
      body: JSON.stringify({ stageId }),
    }),
  crmCerrarOportunidad: (id: string, datos: CerrarOportunidad) =>
    pedir<{ oportunidad: CrmOpportunity }>(`/crm/oportunidades/${id}/cerrar`, {
      method: 'POST',
      body: JSON.stringify(datos),
    }),
  crmActividades: (oportunidadId: string) =>
    pedir<{ actividades: CrmActivity[] }>(`/crm/oportunidades/${oportunidadId}/actividades`),
  crmCrearActividad: (oportunidadId: string, datos: CrearActividad) =>
    pedir<{ actividad: CrmActivity }>(`/crm/oportunidades/${oportunidadId}/actividades`, {
      method: 'POST',
      body: JSON.stringify(datos),
    }),
  crmCompletarActividad: (actividadId: string, hecha: boolean) =>
    enviar(`/crm/actividades/${actividadId}/completar`, { hecha }),
  /** Propone cambios a partir de un texto o de capturas. No toca nada. */
  crmAsistenteInterpretar: (datos: InterpretarAsistente) =>
    pedir<{ propuesta: PropuestaAsistente }>('/crm/asistente/interpretar', {
      method: 'POST',
      body: JSON.stringify(datos),
    }),
  /** Aplica lo que la persona ha confirmado, todo o nada. */
  crmAsistenteAplicar: (datos: AplicarAsistente) =>
    pedir<{ oportunidades: CrmOpportunity[] }>('/crm/asistente/aplicar', {
      method: 'POST',
      body: JSON.stringify(datos),
    }),

  // --- Finanzas ------------------------------------------------------------
  finTarifas: () => pedir<{ tarifas: FinanceRate[] }>('/finanzas/tarifas'),
  /** Las tarifas del equipo sin casa: pagan las horas internas. */
  finTarifasEquipo: () => pedir<{ tarifas: TarifaEquipo[] }>('/finanzas/tarifas-equipo'),
  finFijarTarifa: (datos: FijarTarifaTrabajo) =>
    pedir<{ tarifa: FinanceRate }>('/finanzas/tarifas', {
      method: 'POST',
      body: JSON.stringify(datos),
    }),
  finHoras: (anio: number, mes: number) =>
    pedir<{ horas: TimeEntry[] }>(`/finanzas/horas?anio=${anio}&mes=${mes}`),
  finRegistrarHoras: (datos: RegistrarHoras) =>
    pedir<{ hora?: TimeEntry; gasto?: Expense }>('/finanzas/horas', {
      method: 'POST',
      body: JSON.stringify(datos),
    }),
  finTarifaSugerida: (userId: string | null, propertyId: string | null) =>
    pedir<{ tarifa: TarifaSugerida }>(
      `/finanzas/tarifa-sugerida?${new URLSearchParams({
        ...(userId ? { userId } : {}),
        ...(propertyId ? { propertyId } : {}),
      }).toString()}`,
    ),
  finGastos: (anio: number, mes: number) =>
    pedir<{ gastos: Expense[] }>(`/finanzas/gastos?anio=${anio}&mes=${mes}`),
  finRegistrarGasto: (datos: RegistrarGasto) =>
    pedir<{ gasto: Expense }>('/finanzas/gastos', { method: 'POST', body: JSON.stringify(datos) }),
  /*
    CORREGIR Y QUITAR. Solo Direccion, y el servidor lo exige: aqui no hay mas
    que la puerta. Lo que no se manda no se toca, para que cambiar la fecha no
    obligue a reenviar el resto y pisarlo sin querer.
  */
  finEditarHoras: (id: string, datos: EditarHoras) =>
    pedir<{ hora: TimeEntry }>(`/finanzas/horas/${id}`, {
      method: 'PATCH',
      body: JSON.stringify(datos),
    }),
  finEliminarHoras: (id: string) =>
    pedir<{ ok: true }>(`/finanzas/horas/${id}/eliminar`, { method: 'POST' }),
  finEditarGasto: (id: string, datos: EditarGasto) =>
    pedir<{ gasto: Expense }>(`/finanzas/gastos/${id}`, {
      method: 'PATCH',
      body: JSON.stringify(datos),
    }),
  finEliminarGasto: (id: string) =>
    pedir<{ ok: true }>(`/finanzas/gastos/${id}/eliminar`, { method: 'POST' }),
  finResumen: (anio: number, mes: number) =>
    pedir<{ resumen: ResumenMensual }>(`/finanzas/resumen?anio=${anio}&mes=${mes}`),
  finFacturacion: (propiedadId: string) =>
    pedir<{ facturacion: PropertyBilling }>(`/propiedades/${propiedadId}/facturacion`),
  finExtracto: (partyId: string, anio: number, mes: number) =>
    pedir<{ extracto: ExtractoPropietario }>(
      `/propietarios/${partyId}/extracto?anio=${anio}&mes=${mes}`,
    ),

  // --- Proyectos y tareas --------------------------------------------------
  proyEquipos: () => pedir<{ equipos: Equipo[] }>('/proyectos/equipos'),
  proyCrearEquipo: (datos: { nombre: string; color?: string }) =>
    enviar('/proyectos/equipos', datos),
  proyCrearProyecto: (datos: CrearProyecto) =>
    enviar('/proyectos/proyectos', datos),
  proyAbrir: (id: string) => pedir<{ proyecto: ProyectoDetalle }>(`/proyectos/proyectos/${id}`),
  proyCrearSeccion: (proyectoId: string, datos: CrearSeccion) =>
    enviar(`/proyectos/proyectos/${proyectoId}/secciones`, datos),
  proyCrearTarea: (proyectoId: string, datos: CrearTarea) =>
    pedir<{ tarea: Tarea }>(`/proyectos/proyectos/${proyectoId}/tareas`, {
      method: 'POST',
      body: JSON.stringify(datos),
    }),
  proyEditarTarea: (tareaId: string, datos: EditarTarea) =>
    pedir<{ tarea: Tarea }>(`/proyectos/tareas/${tareaId}`, {
      method: 'PATCH',
      body: JSON.stringify(datos),
    }),
  proyMoverTarea: (tareaId: string, datos: MoverTarea) =>
    pedir<{ tarea: Tarea }>(`/proyectos/tareas/${tareaId}/mover`, {
      method: 'POST',
      body: JSON.stringify(datos),
    }),
  proyMisTareas: () => pedir<{ tareas: Tarea[] }>('/proyectos/mis-tareas'),
  proyAbrirTarea: (tareaId: string) =>
    pedir<{ tarea: TareaDetalle }>(`/proyectos/tareas/${tareaId}`),
  proyComentarTarea: (tareaId: string, texto: string) =>
    pedir<{ comentario: ComentarioTarea }>(`/proyectos/tareas/${tareaId}/comentarios`, {
      method: 'POST',
      body: JSON.stringify({ texto }),
    }),
  proyRenombrarSeccion: (seccionId: string, nombre: string) =>
    pedir<{ seccion: Seccion }>(`/proyectos/secciones/${seccionId}/renombrar`, {
      method: 'POST',
      body: JSON.stringify({ nombre }),
    }),
  proyEtiquetas: () => pedir<{ etiquetas: EtiquetaTarea[] }>('/proyectos/etiquetas'),
  proyEtiquetarTarea: (tareaId: string, nombre: string) =>
    pedir<{ tarea: Tarea }>(`/proyectos/tareas/${tareaId}/etiquetas`, {
      method: 'POST',
      body: JSON.stringify({ nombre }),
    }),
  proyQuitarEtiqueta: (tareaId: string, tagId: string) =>
    pedir<{ tarea: Tarea }>(`/proyectos/tareas/${tareaId}/etiquetas/${tagId}/quitar`, {
      method: 'POST',
    }),
  /** Lo que le toca hoy a quien pregunta: sus tareas con fecha y sus visitas. */
  proyMiDia: (fecha?: string) =>
    pedir<{ dia: MiDia }>(`/proyectos/mi-dia${fecha ? `?fecha=${fecha}` : ''}`),

  // --- Referidos -----------------------------------------------------------
  referidos: (estado?: EstadoReferido) =>
    pedir<{ referidos: Referido[] }>(`/referidos${estado ? `?estado=${estado}` : ''}`),
  crearReferido: (datos: Record<string, unknown>) =>
    pedir<{ referido: Referido }>('/referidos', { method: 'POST', body: JSON.stringify(datos) }),
  convertirReferido: (id: string, datos: { baseCents?: number }) =>
    pedir<{ referido: Referido }>(`/referidos/${id}/convertir`, {
      method: 'POST',
      body: JSON.stringify(datos),
    }),
  descartarReferido: (id: string, motivo: string) =>
    enviar(`/referidos/${id}/descartar`, { motivo }),

  // --- Proveedores ---------------------------------------------------------
  proveedores: (opciones?: { archivados?: boolean; oficio?: Oficio }) => {
    const q = new URLSearchParams();
    if (opciones?.archivados) q.set('archivados', 'true');
    if (opciones?.oficio) q.set('oficio', opciones.oficio);
    const s = q.toString();
    return pedir<{ proveedores: Proveedor[] }>(`/proveedores${s ? `?${s}` : ''}`);
  },
  crearProveedor: (datos: CrearProveedor) =>
    pedir<{ proveedor: Proveedor }>('/proveedores', {
      method: 'POST',
      body: JSON.stringify(datos),
    }),
  editarProveedor: (id: string, datos: EditarProveedor) =>
    pedir<{ proveedor: Proveedor }>(`/proveedores/${id}`, {
      method: 'PATCH',
      body: JSON.stringify(datos),
    }),
  archivarProveedor: (id: string) =>
    pedir<{ proveedor: Proveedor }>(`/proveedores/${id}/archivar`, { method: 'POST' }),
  reactivarProveedor: (id: string) =>
    pedir<{ proveedor: Proveedor }>(`/proveedores/${id}/reactivar`, { method: 'POST' }),

  // --- Calendario ----------------------------------------------------------
  calendario: (anio: number, mes: number, propiedad?: string) => {
    const q = new URLSearchParams({ anio: String(anio), mes: String(mes) });
    if (propiedad) q.set('propiedad', propiedad);
    return pedir<{ eventos: EventoCalendario[] }>(`/calendario?${q.toString()}`);
  },
  crearEvento: (datos: CrearEvento) =>
    pedir<{ evento: EventoCalendario }>('/calendario', {
      method: 'POST',
      body: JSON.stringify(datos),
    }),
  editarEvento: (id: string, datos: EditarEvento) =>
    pedir<{ evento: EventoCalendario }>(`/calendario/${id}`, {
      method: 'PATCH',
      body: JSON.stringify(datos),
    }),
  cambiarEstadoEvento: (id: string, estado: EstadoEvento) =>
    pedir<{ evento: EventoCalendario }>(`/calendario/${id}/estado`, {
      method: 'POST',
      body: JSON.stringify({ estado }),
    }),

  // --- Checklists (plantillas) ---------------------------------------------
  plantillas: (archivadas?: boolean) =>
    pedir<{ plantillas: PlantillaResumen[] }>(
      `/checklists/plantillas${archivadas ? '?archivadas=true' : ''}`,
    ),
  plantilla: (id: string) => pedir<{ plantilla: PlantillaCompleta }>(`/checklists/plantillas/${id}`),
  crearPlantilla: (datos: CrearPlantilla) =>
    pedir<{ plantilla: PlantillaResumen }>('/checklists/plantillas', {
      method: 'POST',
      body: JSON.stringify(datos),
    }),
  editarPlantilla: (id: string, datos: EditarPlantilla) =>
    pedir<{ ok: true }>(`/checklists/plantillas/${id}`, {
      method: 'PATCH',
      body: JSON.stringify(datos),
    }),
  archivarPlantilla: (id: string) =>
    pedir<{ ok: true }>(`/checklists/plantillas/${id}/archivar`, { method: 'POST' }),
  reactivarPlantilla: (id: string) =>
    pedir<{ ok: true }>(`/checklists/plantillas/${id}/reactivar`, { method: 'POST' }),
  crearItemChecklist: (plantillaId: string, datos: CrearItemChecklist) =>
    pedir<{ item: ItemChecklist }>(`/checklists/plantillas/${plantillaId}/items`, {
      method: 'POST',
      body: JSON.stringify(datos),
    }),
  editarItemChecklist: (itemId: string, datos: EditarItemChecklist) =>
    pedir<{ item: ItemChecklist }>(`/checklists/items/${itemId}`, {
      method: 'PATCH',
      body: JSON.stringify(datos),
    }),
  eliminarItemChecklist: (itemId: string) =>
    pedir<{ ok: true }>(`/checklists/items/${itemId}/eliminar`, { method: 'POST' }),

  // --- Integraciones (bóveda de credenciales) ------------------------------
  integraciones: () =>
    pedir<{ integraciones: EstadoIntegracion[] }>('/integraciones/estado'),
  guardarCredencial: (proveedor: string, datos: GuardarCredencial) =>
    pedir<{ integracion: EstadoIntegracion }>(`/integraciones/${proveedor}`, {
      method: 'PUT',
      body: JSON.stringify(datos),
    }),
  desconectarIntegracion: (proveedor: string) =>
    pedir<{ ok: true }>(`/integraciones/${proveedor}/desconectar`, { method: 'POST' }),

  // --- Segundo factor (2FA) ------------------------------------------------
  dosFactoresEstado: () => pedir<{ estado: Estado2fa }>('/2fa/estado'),
  dosFactoresIniciar: () => pedir<{ alta: Inicio2fa }>('/2fa/iniciar', { method: 'POST' }),
  dosFactoresConfirmar: (codigo: string) =>
    pedir<{ estado: Estado2fa }>('/2fa/confirmar', {
      method: 'POST',
      body: JSON.stringify({ codigo }),
    }),
  dosFactoresDesactivar: (codigo: string) =>
    pedir<{ estado: Estado2fa }>('/2fa/desactivar', {
      method: 'POST',
      body: JSON.stringify({ codigo }),
    }),

  // --- IA y analítica ------------------------------------------------------
  iaEstado: () => pedir<{ ia: EstadoIa }>('/ia/estado'),
  /** Prueba de verdad: hace una llamada minima al proveedor. Cuesta, y por eso se pide. */
  iaProbar: () => pedir<{ prueba: PruebaIa }>('/ia/probar', { method: 'POST' }),
  iaAnomalias: (mesesAtras?: number) =>
    pedir<{ anomalias: AnomaliaGasto[] }>(
      `/ia/anomalias${mesesAtras ? `?mesesAtras=${mesesAtras}` : ''}`,
    ),
  iaClasificarIncidencia: (texto: string) =>
    pedir<{ clasificacion: ClasificacionIncidencia }>('/ia/clasificar-incidencia', {
      method: 'POST',
      body: JSON.stringify({ texto }),
    }),

  marcarCobroGasto: (gastoId: string, estadoCobro: EstadoCobro) =>
    pedir<{ estadoCobro: EstadoCobro }>(`/gastos/${gastoId}/cobro`, {
      method: 'POST',
      body: JSON.stringify({ estadoCobro }),
    }),

  // --- Ajustes de la empresa -----------------------------------------------
  organizacion: () => pedir<{ organizacion: Organizacion }>('/ajustes/organizacion'),
  guardarOrganizacion: (datos: GuardarOrganizacion) =>
    pedir<{ organizacion: Organizacion }>('/ajustes/organizacion', {
      method: 'POST',
      body: JSON.stringify(datos),
    }),
  marca: () => pedir<{ marca: Marca }>('/ajustes/marca'),
  guardarMarca: (datos: GuardarMarca) =>
    pedir<{ marca: Marca }>('/ajustes/marca', { method: 'POST', body: JSON.stringify(datos) }),
  categorias: () => pedir<{ categorias: Categoria[] }>('/ajustes/categorias'),
  crearCategoria: (datos: CrearCategoria) =>
    pedir<{ categoria: Categoria }>('/ajustes/categorias', {
      method: 'POST',
      body: JSON.stringify(datos),
    }),
  editarCategoria: (id: string, datos: EditarCategoria) =>
    pedir<{ categoria: Categoria }>(`/ajustes/categorias/${id}`, {
      method: 'POST',
      body: JSON.stringify(datos),
    }),
  eliminarCategoria: (id: string) =>
    pedir<{ ok: true }>(`/ajustes/categorias/${id}/eliminar`, { method: 'POST' }),
  preferenciasAviso: () => pedir<{ preferencias: PreferenciaAviso[] }>('/ajustes/avisos'),
  guardarPreferenciaAviso: (tipo: TipoAviso, push: boolean) =>
    pedir<{ preferencias: PreferenciaAviso[] }>('/ajustes/avisos', {
      method: 'POST',
      body: JSON.stringify({ tipo, push }),
    }),

  // --- Llaves de acceso (Face ID) ------------------------------------------
  llaves: () => pedir<{ llaves: LlaveAcceso[] }>('/llaves'),
  llaveDesafioAlta: () => pedir<{ opciones: unknown }>('/llaves/desafio', { method: 'POST' }),
  llaveAlta: (respuesta: unknown, nombre: string) =>
    pedir<{ llave: LlaveAcceso }>('/llaves', {
      method: 'POST',
      body: JSON.stringify({ respuesta, nombre }),
    }),
  llaveRevocar: (id: string, motivo: string) =>
    pedir<{ ok: true }>(`/llaves/${id}/revocar`, {
      method: 'POST',
      body: JSON.stringify({ motivo }),
    }),
  llaveDesafioAcceso: () =>
    pedir<{ opciones: unknown }>('/auth/llaves/desafio', { method: 'POST' }),
  llaveEntrar: (respuesta: unknown) =>
    pedir<{ usuario: UsuarioSesion }>('/auth/llaves/entrar', {
      method: 'POST',
      body: JSON.stringify({ respuesta }),
    }),

  // --- Importacion de arranque ---------------------------------------------
  importacionEstado: () => pedir<EstadoImportacion>('/importacion/estado'),
  importarChecklists: (datos: ImportarChecklists) =>
    pedir<{ resumen: ResumenImportacionChecklists }>('/importacion/checklists', {
      method: 'POST',
      body: JSON.stringify(datos),
    }),
  importarProyectos: (datos: ImportarProyectos) =>
    pedir<{ resumen: ResumenImportacionProyectos }>('/importacion/proyectos', {
      method: 'POST',
      body: JSON.stringify(datos),
    }),
  importarInstantanea: (instantanea: Instantanea, passwordInicial: string) =>
    pedir<{ resumen: ResumenImportacion }>('/importacion/instantanea', {
      method: 'POST',
      body: JSON.stringify({ instantanea, passwordInicial }),
    }),
  importarOportunidades: (datos: ImportarOportunidades) =>
    pedir<{ resumen: ResumenImportacionCrm }>('/importacion/oportunidades', {
      method: 'POST',
      body: JSON.stringify(datos),
    }),
};
